import { AlertSettingsVariable } from 'src/app/hickory-api';

export class PlaceholderUtilities {
  
  static extractPlaceholders(input: string): string[] {
    const matches = input.match(/{{\s*([^{}]+?)\s*}}/g);
    if (!matches) return [];
    
    return matches.map((match) => match.replace(/{{\s*|\s*}}/g, ''));
  }
  
  static inputHasPlaceholders(input: string): boolean {
    return this.extractPlaceholders(input).length != 0;
  }

  static inputHasContactPlaceholders(input: string): boolean {
    const templateValues = this.extractPlaceholders(input);
    return templateValues.some(str => str.toLowerCase().startsWith('contact'));
  }

  static bracesAreValid(input: string): boolean {
    const openCount = (input.match(/{{/g) || []).length;
    const closeCount = (input.match(/}}/g) || []).length;

    return openCount <= closeCount;
  }

  static variablesAreValid(input: string, availableVariables: AlertSettingsVariable[]): boolean {
    const templateValues = PlaceholderUtilities.extractPlaceholders(input);

    for (const value of templateValues) {
      const found = availableVariables.some((variable) => variable.placeHolder === value);

      if (!found) {
        return false;
      }
    }

    return true;
  }
}
